module.exports = "/_next/static/images/logo-no-slogan-light-a4c5e41db5c18a0962b3ed987993f42c.svg";